import { Row, Col, Card, Input, Button } from "antd";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { ArrowLeftOutlined } from "@ant-design/icons";
function ViewEmailTemplate() {
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  const rawHTML = `
  <html lang="en">
    <body style="font-family: 'Lato', 'Merriweather', 'Roboto', sans-serif;">
      <div className="mainEmailWraper" style="max-width: 575px; margin: 0 auto;border: 1.17px solid #D0D0D0;border-radius: 8px;">
        <div className="emailHeader" style="padding: 10px;background-color: #F4F9EC;border-radius: 8px 8px 0 0;">
          <div className="logoOuter" style="text-align:center;">
            <img src="https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/invent-colab-obj-bucket/krat-easy/facility/pocket-chef_1743593215624.png" alt="Logo" style="width:100px;" />
          </div>
        </div>

        <!-- BODY_PLACEHOLDER -->

        <div style="padding: 10px;font-size: 14px; background-color: #F4F9EC; color: #000; text-align:center;">
          <div style="font-size: 16px; font-weight: 600; color: #000000;">Get in touch</div>
          <div style="font-size: 14px; font-weight: 400; color: #000000;">
            <p href="tel:+91 9876543210" style="text-decoration: none;color: #000000;font-size: 14px;margin: 5px 0px;">+91 9876543210</p>
          </div>
          <div style="font-size: 14px; font-weight: 400; color: #000000;">
            <a href="mailto:sojo.com" style="text-decoration: none; color: #000000; font-size: 14px;">sojo.com</a>
          </div>
          <ul style="list-style: none; padding: 0; margin: 0; margin-top: 16px; text-align: center;">
            <li style="display: inline-block; margin:0 8px;">
              <a href="https://mail.google.com/" style="display: flex; width: 40px; height: 40px; border-radius: 50px; background-color: #000000; position:relative;" target="_blank">
                <img src="https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/invent-colab-obj-bucket/krat-easy/facility/pocket-chef_1743593658508.png" alt="Gmail" style="margin:auto;position: absolute; inset: 0;" />
              </a>
            </li>
            <li style="display: inline-block; margin:0 8px;">
              <a href="https://www.linkedin.com/" style="display: flex; width: 40px; height: 40px; border-radius: 50px; background-color: #000000; position:relative;" target="_blank">
                <img src="https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/invent-colab-obj-bucket/krat-easy/facility/pocket-chef_1743593692469.png" alt="LinkedIn" style="margin:auto;position: absolute; inset: 0;" />
              </a>
            </li>
            <li style="display: inline-block; margin:0 8px;">
              <a href="https://twitter.com/" style="display: flex; width: 40px; height: 40px; border-radius: 50px; background-color: #000000; position:relative;" target="_blank">
                <img src="https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/invent-colab-obj-bucket/krat-easy/facility/pocket-chef_1743593784793.png" alt="Twitter" style="margin:auto;position: absolute; inset: 0;" />
              </a>
            </li>
            <li style="display: inline-block; margin:0 8px;">
              <a href="https://www.facebook.com/" style="display: flex; width: 40px; height: 40px; border-radius: 50px; background-color: #000000; position:relative;" target="_blank">
                <img src="https://api-ap-south-mum-1.openstack.acecloudhosting.com:8080/invent-colab-obj-bucket/krat-easy/facility/pocket-chef_1743593729983.png" alt="Facebook" style="margin:auto;position: absolute; inset: 0;" />
              </a>
            </li>
          </ul>
        </div>

        <div className="emailFooter" style="padding: 10px;background-color: #3b747d;border-radius: 0 0 5px 5px;text-align: center;">
          <div className="title" style="font-size: 14px; color: #fff; font-weight: 500;">Copyright © 2024 sojo. All rights reserved.</div>
        </div>
      </div>
    </body>
  </html>
  `;

  const getProcessedHTML = () => {
    const bodyContent = `
      <div className="emailTempBody" style="">
        <div style="padding: 25px 16px; background-color: #fff; gap: 16px;">
          ${list?.description || "<p>No content found.</p>"}
        </div>
      </div>
    `;
    return rawHTML.replace("<!-- BODY_PLACEHOLDER -->", bodyContent);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(params.id);
  }, []);

  const fetchData = (id) => {
    request({
      url: `/admin/email-template/view/${id}`,
      method: "PUT",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data);
      },
      onError: (error) => {
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  return (
    <div>
      <div className="float-left mb-2">
        <Button
          className="ant-btn ant-btn-primary"
          onClick={() => navigate(-1)}
        >
          <ArrowLeftOutlined />
        </Button>
      </div>
      <Card title="Email Template Details">
        <div className="view-main-list">
          <div className="view-inner-cls">
            <h5>Title:</h5>
            <h6>{list ? list.title : "--"}</h6>
          </div>
          <div className="view-inner-cls">
            <h5>Subject:</h5>
            <h6>{list ? list.subject : "--"}</h6>
          </div>
          <div className="view-inner-cls">
            <h5>Status: </h5>
            <h6>{list ? (list.is_active ? "Active" : "Inactive") : "--"}</h6>
          </div>
        </div>
      </Card>

      <Card className="mt-3">
        <Row gutter={16}>
          <Col span={24}>
            <div dangerouslySetInnerHTML={{ __html: getProcessedHTML() }} />
          </Col>
        </Row>
      </Card>
    </div>
  );
}

export default ViewEmailTemplate;
